var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
import { getTemplate } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var GroupStickyHeaderVue2 = {
  name: 'KendoGroupStickyHeader',
  props: {
    group: String,
    render: Object
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      group = _a.group,
      render = _a.render;
    var defaulGroupStickyHeader = h("div", {
      "class": "k-list-group-sticky-header"
    }, [h("div", {
      "class": "k-list-header-text"
    }, [group])]);
    return getTemplate.call(this, {
      h: h,
      template: render,
      defaultRendering: defaulGroupStickyHeader,
      additionalProps: __assign({}, this.$props)
    });
  }
};
/**
 * @hidden
 */
var GroupStickyHeader = GroupStickyHeaderVue2;
export { GroupStickyHeader, GroupStickyHeaderVue2 };